import { render, staticRenderFns } from "./NoRegister.vue?vue&type=template&id=48732ff5&"
import script from "./NoRegister.vue?vue&type=script&lang=js&"
export * from "./NoRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports